import * as React from 'react';

const RfidDisabledSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            d="M13.055 14.116a2.386 2.386 0 01-1.055.245c-1.313 0-2.381-1.059-2.381-2.358 0-.383.093-.746.257-1.066L7.818 8.88a5.15 5.15 0 00.478 6.792l-.673.666a6.085 6.085 0 01-.48-8.134L5.12 6.182a8.897 8.897 0 00.48 12.156l-.672.667a9.834 9.834 0 01-.48-13.495L2.646 3.707 3.354 3 21.03 20.678l-.707.707-7.269-7.269zm-2.444-2.444a1.4 1.4 0 00-.04.33 1.423 1.423 0 001.75 1.38l-1.71-1.71zm3.693.927l-.911-.91a1.427 1.427 0 00-1.062-1.062l-.91-.911a2.4 2.4 0 01.579-.07c1.313 0 2.381 1.057 2.381 2.357 0 .206-.027.406-.077.596zm2.83 2.83l-.686-.685a5.15 5.15 0 00-.744-6.409l.673-.666a6.086 6.086 0 01.757 7.76zm2.713 2.714l-.675-.676a8.897 8.897 0 00-.774-11.8l.673-.666a9.834 9.834 0 01.776 13.142z"
        />
    </svg>
);

RfidDisabledSvg.displayName = 'RfidDisabledSvg';
export default RfidDisabledSvg;
